import Lifecycles from "./Lifecycles";

export default Lifecycles;
